/**
 * Created by Ning Jiang on 3/6/2019.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export class MonkeysGoldInitialWPView extends BaseView {

    private _spineSymbols:PIXI.spine.Spine[][];

    constructor() {
        super();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name).addChild(this);
    }

    protected initAnimations():void {
        this._spineSymbols = [];
        for(let i:number = 0; i < 6; i++) {
            const reel:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 6; j++) {
                const symbol:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("spineInitialWin"));
                symbol.position.x = Helper.getSymbolPositions(i, j)[0];
                symbol.position.y = Helper.getSymbolPositions(i, j)[1];
                symbol.visible = false;
                this.addChild(symbol);
                reel.push(symbol);
            }
            this._spineSymbols.push(reel);
        }
    }

    public getSymbolInitialWinTL(reel:number, row:number, symbolSize:number):TimelineLite {
        this._spineSymbols[reel][row].position.x = Helper.getSymbolPositions(reel, row)[0];
        this._spineSymbols[reel][row].position.y = Helper.getSymbolPositions(reel, row)[1];
        if(symbolSize == 2) {
            this._spineSymbols[reel][row].position.x -= 60;
            this._spineSymbols[reel][row].position.y -= 50;
        } else if(symbolSize == 3) {
            this._spineSymbols[reel][row].position.x -= 120;
            this._spineSymbols[reel][row].position.y -= 100;
        }
        const symbolInitialWin:TimelineLite = new TimelineLite();
        symbolInitialWin.add(() => this.addChild(this._spineSymbols[reel][row]));
        symbolInitialWin.add(() => this._spineSymbols[reel][row].skeleton.setSkin(null));
        symbolInitialWin.add(() => this._spineSymbols[reel][row].skeleton.setSkinByName("default"));
        symbolInitialWin.add(() => this._spineSymbols[reel][row].skeleton.setSlotsToSetupPose());
        symbolInitialWin.add(() => this._spineSymbols[reel][row].updateTransform());
        symbolInitialWin.add(() => this._spineSymbols[reel][row].visible = true);
        symbolInitialWin.add(new SpineTween(this._spineSymbols[reel][row], 0, "initial_win_" + symbolSize + "x" + symbolSize, 0));
        symbolInitialWin.add(() => this._spineSymbols[reel][row].visible = false);
        symbolInitialWin.add(() => this._spineSymbols[reel][row].position.x = Helper.getSymbolPositions(reel, row)[0]);
        symbolInitialWin.add(() => this._spineSymbols[reel][row].position.y = Helper.getSymbolPositions(reel, row)[1]);

        return symbolInitialWin;
    }

    public cleanupSpineWinSymbols():void {
        for(let i:number = 0; i < 6; i++) {
            for(let j:number = 0; j < 6; j++) {
                this._spineSymbols[i][j].visible = false;
            }
        }
    }

    public abort():void {

    }
}